import {useEffect, useState} from 'react';
import {DeliveryTaskOrderType} from 'pages/delivery/graphql/types/DeliveryTaskOrderType';

interface TaskStats {
    newCount: number;
    routeNames: string[];
    transferInCount: number;
    transferInNames: string[];
    transferOutCount: number;
    transferOutNames: string[];
    returnCount: number;
}

export const useDeliveryTaskStats = (deliveryTaskOrderList?: DeliveryTaskOrderType[]) => {
    const [stats, setStats] = useState<TaskStats>({
        newCount: 0,
        routeNames: [],
        transferInCount: 0,
        transferInNames: [],
        transferOutCount: 0,
        transferOutNames: [],
        returnCount: 0,
    });

    useEffect(() => {
        if (!deliveryTaskOrderList) return;
        const tasks = deliveryTaskOrderList;
        if (!tasks.length) return;

        const newData = tasks.filter(item => {
            const order = item?.orderWithAddress?.order;
            // 875: 新分配包裹和转入包裹统一展示在新分配入口
            return ((item?.isNewAssignment || item?.isTransferIn) && !item.isPickedUp && !order?.isAbnormal && !item?.isTransferOut && !order?.isFinished);
        }) || [];
        const newCount = newData?.length;
        const routeNames = Array.from(new Set(tasks.filter(item => item?.routeName).map(item => item.routeName))).filter(Boolean) as string[];

        const transferInData = tasks.filter(item => {
            const order = item?.orderWithAddress?.order;
            
            return item?.isTransferIn
                && !item.isPickedUp
                && !order?.isAbnormal
                && !order?.isFinished;
        }) || [];

        const transferInCount = transferInData?.length;
        const transferInNames = Array.from(new Set(transferInData.map(item => item.transferFromDriverName))).filter(Boolean) as string[];

        const transferOutData = tasks.filter(item => item?.isTransferOut && !item.isAbnormal && !item?.orderWithAddress?.order?.isFinished) || [];
        const transferOutCount = transferOutData?.length;
        const transferOutNames = Array.from(new Set(transferOutData.map(item => item.transferFromDriverName))).filter(Boolean) as string[];

        const returnCount = tasks.filter(item => item?.isPickedUp && item.isAbnormal && !item.isDelivered
            && !item?.orderWithAddress?.order?.isReturnToWhsScanned && !item?.orderWithAddress?.order?.isFinished).length;

        setStats({
            newCount,
            routeNames,
            transferInCount,
            transferInNames,
            transferOutCount,
            transferOutNames,
            returnCount
        });
    }, [deliveryTaskOrderList]);

    return stats;
};